import { DISPLAY_FROM_SHOPFRONT, DISPLAY_TO_SHOPFRONT } from "./DisplayEvents";

type DisplayWorkerMessageCallback = (type: DISPLAY_FROM_SHOPFRONT, body: any) => void;

export default class DisplayWorker {
    protected broadcastChannel: null | BroadcastChannel = null;

    constructor(
        protected receiver: null | PresentationReceiver,
        protected callback: DisplayWorkerMessageCallback
    ) {
        this.handleNewConnection = this.handleNewConnection.bind(this);
        this.handleBroadcastMessage = this.handleBroadcastMessage.bind(this);

        if(receiver) {
            receiver.connectionList
                .then(list => {
                    list.connections.map(this.handleNewConnection);

                    list.addEventListener("connectionavailable", e => {
                        const connection = (e as PresentationConnectionAvailableEvent).connection;

                        this.handleNewConnection(connection);
                    });
                });
        } else {
            this.broadcastChannel = new BroadcastChannel("CustomerDisplayChannel");

            this.broadcastChannel.addEventListener("message", this.handleBroadcastMessage);
            this.broadcastChannel.postMessage({
                type: DISPLAY_TO_SHOPFRONT.DISPLAY_READY,
                body: "",
            });
        }
    }

    /**
     * Disconnect the broadcast channel
     */
    public close(): void {
        if(this.broadcastChannel) {
            this.broadcastChannel.close();
        }
    }

    /**
     * Handles the messages that the display worker processes, passes the other messages to the customer display
     * @param type
     * @param body
     * @protected
     */
    protected handleMessage(
        type: DISPLAY_FROM_SHOPFRONT,
        body: unknown
    ): void {
        switch(type) {
            case DISPLAY_FROM_SHOPFRONT.DISPLAY_HEARTBEAT_REQUEST:
                if(typeof body !== "string") {
                    return;
                }

                void this.handleHeartbeatRequest(body);
                break;
            case DISPLAY_FROM_SHOPFRONT.DISPLAY_CLOSE:
                if(!this.receiver) {
                    window.close();
                }

                break;
            default:
                this.callback(type, body);
                break;
        }
    }

    protected async handleHeartbeatRequest(id: string): Promise<void> {
        if(!this.broadcastChannel) {
            return;
        }

        this.broadcastChannel.postMessage({
            type: DISPLAY_TO_SHOPFRONT.DISPLAY_HEARTBEAT_RESPONSE,
            body: id,
        });
    }

    // Broadcast API message handler
    protected handleBroadcastMessage({ data }: MessageEvent): void {
        const { type, body } = data;

        if(typeof type !== "string") {
            return;
        }

        if(!(type in DISPLAY_FROM_SHOPFRONT)) {
            return;
        }

        this.handleMessage(type as DISPLAY_FROM_SHOPFRONT, body);
    }

    // Presentation API message handler
    protected handleNewConnection(connection: PresentationConnection): void {
        connection.addEventListener("message", e => {
            const data = JSON.parse((e as MessageEvent).data);

            this.handleMessage(data.type, data.body);
        });

        connection.send(JSON.stringify({
            type: DISPLAY_TO_SHOPFRONT.DISPLAY_READY,
            body: "",
        }));
    }
}
